import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'
import 'video.js/dist/video-js.css'




Vue.config.productionTip = false

import * as net from '@/common/net'
Vue.prototype.$net = net;
import * as cache from '@/common/cache'
Vue.prototype.$cache = cache;
//localStorage.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJkdyIsImV4cCI6MTczMjQxMjMxNywibWFwIjp7ImNyZWF0b3IiOiIxIiwiYWRtaW5Vc2VyIjoiMSIsImdsb2JhbEFwaSI6Imdsb2JhbEFwaSJ9fQ.7Gc_L4uXmlOUNYtcsEMf-EATicSHVPlVHmx2zokca5w'

Vue.prototype.$bus = new Vue();

Vue.prototype.$eventBus = new Vue();

import panZoom from 'vue-panzoom'

Vue.use(Antd);
Vue.use(panZoom);
const setHtmlFontSize = () => {
  const htmlDom = document.getElementsByTagName('html')[0];
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  // if (htmlWidth >= 750) {
  //   htmlWidth = 750;
  // }
  if (htmlWidth <= 320) {
    htmlWidth = 320;
  }
  htmlDom.style.fontSize = `${ htmlWidth / 150 }px`;
};
window.onresize = setHtmlFontSize;
setHtmlFontSize();

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

import moment from 'moment'
Vue.prototype.$moment = moment;

Vue.prototype.$dscode = 'GS09-045'
Vue.prototype.$day = new Date()

import './common/filter' // global filter

export const EventBus = new Vue();